import { render, staticRenderFns } from "./SaveArticle.vue?vue&type=template&id=549d3710&scoped=true"
import script from "./SaveArticle.vue?vue&type=script&lang=js"
export * from "./SaveArticle.vue?vue&type=script&lang=js"
import style0 from "./SaveArticle.vue?vue&type=style&index=0&id=549d3710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d3710",
  null
  
)

export default component.exports